<dx-popup
    #editorCashReceipts
    minWidth="150px"
    minHeight="150px"
    width="55%"
    height="80%"
    [title]="title"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onShown($event)"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box *ngIf="cashReceiptRawItem" width="100%" height="100%" direction="col" class="cash-receipt-box">
            <dxi-item baseSize="auto" *ngIf="cashReceipt?.cmCashReceiptId">
                <div *dxTemplate class="history-icon">
                    <i
                        [ngClass]="iconHistory"
                        class="fa-1-5x icon-content cc-icon-content"
                        (click)="onTransactioLogClick(cashReceiptRawItem)"
                    ></i>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-form #editorForm class="cash-receipt-form-group" [colCount]="2" labelLocation="left">
                    <dxi-item [isRequired]="true">
                        <dxo-label text="Receipt Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box
                                openOnFieldClick="true"
                                type="date"
                                [disabled]="!isAllowEdit"
                                [useMaskBehavior]="true"
                                [(value)]="cashReceiptRawItem.receiveDate"
                            >
                                <dx-validator>
                                    <dxi-validation-rule
                                        type="required"
                                        message="Receipt Date is required"
                                    ></dxi-validation-rule>
                                </dx-validator>
                            </dx-date-box>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxo-label text="Payer"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box
                                [disabled]="!isAllowEdit"
                                [maxLength]="200"
                                [(value)]="cashReceiptRawItem.payer"
                            ></dx-text-box>
                        </div>
                    </dxi-item>

                    <dxi-item [isRequired]="true">
                        <dxo-label text="Post Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box
                                openOnFieldClick="true"
                                type="date"
                                [disabled]="!isAllowEdit"
                                [useMaskBehavior]="true"
                                [(value)]="cashReceiptRawItem.postDate"
                            >
                                <dx-validator>
                                    <dxi-validation-rule
                                        type="required"
                                        message="Post Date is required"
                                    ></dxi-validation-rule>
                                </dx-validator>
                            </dx-date-box>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxo-label text="Payment Method"></dxo-label>
                        <div *dxTemplate>
                            <dx-select-box
                                displayExpr="displayText"
                                valueExpr="code"
                                [disabled]="!isAllowEdit"
                                [searchEnabled]="true"
                                [dataSource]="paymentType"
                                [(value)]="cashReceiptRawItem.paymentMethod"
                                (onValueChanged)="onPaymentMethodClick($event)"
                            ></dx-select-box>
                        </div>
                    </dxi-item>

                    <dxi-item [isRequired]="true">
                        <dxo-label text="Description"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box [maxLength]="200" [(value)]="cashReceiptRawItem.description">
                                <dx-validator>
                                    <dxi-validation-rule
                                        type="required"
                                        message="Description is required"
                                    ></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxo-label text="Transaction Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box
                                openOnFieldClick="true"
                                type="date"
                                [useMaskBehavior]="true"
                                [disabled]="!isAllowEdit"
                                [(value)]="cashReceiptRawItem.transactionDate"
                            ></dx-date-box>
                        </div>
                    </dxi-item>

                    <dxi-item itemType="empty"></dxi-item>

                    <dxi-item>
                        <dxo-label text="Transaction Number"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box
                                [disabled]="!isAllowEdit"
                                [maxLength]="200"
                                [(value)]="cashReceiptRawItem.transactionNumber"
                            ></dx-text-box>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div class="new-line-item-btn">
                    <dx-button
                        text="New Line Item"
                        type="default"
                        [width]="135"
                        [height]="26"
                        [visible]="isAllowEdit"
                        (onClick)="addNewLineItem($event)"
                        [template]="'buttonTemplate'"
                    >
                        <div *dxTemplate="let buttonData of 'buttonTemplate'">
                            <div class="button-item-container">
                                <i [ngClass]="iconPlus"></i>
                                <div class="button-content">{{ buttonData.text }}</div>
                                <app-security-info
                                    iconColor="cc-white-icon"
                                    securityIndicator="SHIELD"
                                    apiAction="POST"
                                    apiUrl="api/cb/cm/cr"
                                ></app-security-info>
                            </div>
                        </div>
                    </dx-button>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <dx-data-grid
                    #cashReceiptEditorGrid
                    ccAddNewRow
                    height="95%"
                    keyExpr="itemId"
                    [dataSource]="cashReceiptRawItem.items"
                    [highlightChanges]="true"
                    [repaintChangesOnly]="true"
                    [allowColumnReordering]="true"
                    [allowColumnResizing]="true"
                    [columnAutoWidth]="true"
                    [showBorders]="true"
                    [showColumnLines]="true"
                    [showRowLines]="true"
                    (onRowUpdated)="onRowUpdated($event)"
                    (onContentReady)="onEditorContentReady($event)"
                    (onAddNewRow)="addNewLineItem()"
                >
                    <dxo-editing
                        mode="cell"
                        refreshMode="full"
                        selectTextOnEditStart="true"
                        allowUpdating="true"
                        [useIcons]="true"
                    ></dxo-editing>
                    <dxo-pager [visible]="false"></dxo-pager>
                    <dxo-paging [enabled]="false"></dxo-paging>
                    <dxo-load-panel [enabled]="false"></dxo-load-panel>

                    <ng-container *ngIf="isAllowEdit">
                        <dxi-column
                            caption="Action"
                            cellTemplate="actionCellTemplate"
                            [width]="70"
                            [allowEditing]="false"
                            [showInColumnChooser]="false"
                        ></dxi-column>
                    </ng-container>
                    <dxi-column
                        dataType="number"
                        caption="Item #"
                        cellTemplate="itemNumber"
                        [allowEditing]="false"
                    ></dxi-column>
                    <dxi-column
                        dataField="offsetGLAccountNumber"
                        dataType="string"
                        headerCellTemplate="glAccountHeaderCellTemplate"
                        width="250"
                        allowSorting="false"
                        editCellTemplate="glAccountTemplate"
                        [showEditorAlways]="isAllowGLAccountEdit || isAllowEdit"
                        [allowEditing]="isAllowGLAccountEdit || isAllowEdit"
                    >
                        <dxo-lookup
                            [dataSource]="offsetGLAccountNumberSource"
                            displayExpr="displayText"
                            valueExpr="glAccountNumber"
                        ></dxo-lookup>
                    </dxi-column>

                    <ng-container *ngIf="entityUsesSubcategory">
                        <dxi-column
                            dataField="subCategoryCode"
                            dataType="string"
                            caption="Sub Category"
                            width="150"
                            allowSorting="false"
                            [allowEditing]="isAllowLimitedEdit || isAllowEdit"
                            [showEditorAlways]="isAllowLimitedEdit || isAllowEdit"
                            editCellTemplate="subCategoryTemplate"
                        ></dxi-column>
                    </ng-container>

                    <dxi-column
                        dataField="amount"
                        dataType="number"
                        caption="Amount"
                        editorType="dxNumberBox"
                        [showEditorAlways]="isAllowEdit"
                        [allowEditing]="isAllowEdit"
                        [format]="currencyFormat"
                        [editorOptions]="{ disabled: !isAllowEdit, format: currencyFormat }"
                    ></dxi-column>

                    <dxi-column
                        dataField="description"
                        dataType="string"
                        caption="Description"
                        [allowEditing]="isAllowLimitedEdit || isAllowEdit"
                        [showEditorAlways]="isAllowLimitedEdit || isAllowEdit"
                        [editorOptions]="{ showClearButton: true }"
                    ></dxi-column>

                    <ng-container *ngIf="dimensionSource.length > 0">
                        <ng-container *ngFor="let col of dimensionSource">
                            <dxi-column
                                width="150"
                                dataType="string"
                                allowSorting="false"
                                [dataField]="col.code"
                                [caption]="col"
                                headerCellTemplate="requiredDimensionColumnHeaderTemplate"
                                [showEditorAlways]="isAllowEdit || isAllowGLAccountEdit"
                                [editorOptions]="{ disabled: disableGLAccountEditor, placeholder: '' }"
                                [allowEditing]="isAllowEdit || isAllowGLAccountEdit"
                            >
                                <dxo-lookup
                                    [dataSource]="col.options"
                                    displayExpr="text"
                                    valueExpr="code"
                                    allowClearing="true"
                                ></dxo-lookup>
                            </dxi-column>
                        </ng-container>
                    </ng-container>

                    <div *dxTemplate="let header of 'glAccountHeaderCellTemplate'">
                        GL Account No
                        <sup class="cc-text-required">*</sup>
                    </div>

                    <div *dxTemplate="let header of 'requiredDimensionColumnHeaderTemplate'">
                        {{ header.column.caption.text }}
                        <sup *ngIf="header.column.caption.required" class="cc-text-required">*</sup>
                    </div>

                    <div *dxTemplate="let cellInfo of 'subCategoryTemplate'">
                        <dx-select-box
                            displayExpr="title"
                            valueExpr="code"
                            [searchEnabled]="true"
                            [dataSource]="cellInfo.data.subCategorySource"
                            [(value)]="cellInfo.data.subCategoryCode"
                            (onValueChanged)="onSubCategoryChanged($event, cellInfo)"
                        ></dx-select-box>
                    </div>

                    <div *dxTemplate="let d of 'actionCellTemplate'">
                        <div class="centered-icon">
                            <dx-button
                                type="danger"
                                [icon]="iconDelete"
                                [disabled]="!isDeleteAllow"
                                (onClick)="onDeleteCRFromGrid(d.data)"
                            ></dx-button>
                        </div>
                    </div>

                    <div *dxTemplate="let item of 'itemNumber'">
                        <span>
                            {{ item.row.rowIndex + 1 }}
                        </span>
                    </div>

                    <div *dxTemplate="let cellInfo of 'glAccountTemplate'">
                        <app-grid-cell-multi-column-selector
                            [name]="'GL Accounts'"
                            [gridSource]="offsetGLAccountNumberSource"
                            [cellInfo]="cellInfo"
                            [disabled]="disableGLAccountEditor"
                            [dropDownButtonTemplate]="'dropDownButton'"
                            [dropDownOptions]="{ width: 250 }"
                            [valueExpr]="'glAccountNumber'"
                            [displayExpr]="'displayText'"
                            [columnDef]="glAccountColumns"
                            [showClearButton]="true"
                            [placeholder]="'Select GL Account...'"
                            (gridSelectionEvent)="onOffsetGLAccountSelection($event.selectedRow, cellInfo)"
                        ></app-grid-cell-multi-column-selector>
                    </div>

                    <dxo-summary [calculateCustomSummary]="calculateCustomSummary">
                        <dxi-total-item
                            column="amount"
                            summaryType="custom"
                            alignment="right"
                            dataType="number"
                            displayFormat="Total {0}"
                            [valueFormat]="currencyFormat"
                        ></dxi-total-item>
                    </dxo-summary>
                </dx-data-grid>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div class="note">
                        <i>
                            Note: A/R Default Bank:
                            <strong>{{ defaultBankName }}</strong>
                        </i>
                    </div>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    hint="Close"
                                    [icon]="iconClose"
                                    (onClick)="onHidden()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="danger"
                                    text="Delete"
                                    hint="Delete"
                                    [icon]="iconDelete"
                                    [visible]="cashReceipt?.allowDelete"
                                    (onClick)="onDeleteCashReceipt()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Reverse"
                                    hint="Reverse"
                                    [icon]="iconReverse"
                                    [visible]="cashReceipt?.allowReverse"
                                    (onClick)="onReverseCashReceipt()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Save"
                                    hint="Save"
                                    [icon]="iconSave"
                                    (onClick)="onCashReceiptSave()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-transaction-history
    *ngIf="displayTransactionLogPopUp"
    [title]="transactionLogTitle"
    [transactionLogResultData]="transactionLogResultData"
    (onTransactionLogClose)="onTransactionLogClose($event)"
></app-transaction-history>

<app-cash-receipt-reverse-editor
    *ngIf="displayCashReceiptReverseEditor"
    [visible]="displayCashReceiptReverseEditor"
    [cashReceiptParams]="cashReceiptParams"
    (onClose)="onReverseEditorClose($event)"
></app-cash-receipt-reverse-editor>

<dx-load-panel
    #loadPanelCashRecieptEditor
    *ngIf="loadingVisible"
    [position]="{ of: 'body' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #cashReceiptEditorMessageBox></cc-message-box>
